var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('create-credentials',{attrs:{"submit-button-text":"Crear Contraseña","action":"create"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }